import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
/**
 * Custom hook to detect page navigation and execute a callback function.
 *
 * @param callback - A function to execute when the page navigation occurs.
 * The function receives the current path and the previous path as arguments.
 */
const usePageNavigation = (
  callback: (currentPath: string, previousPath: string) => void,
) => {
  const location = useLocation();
  const previousPath = useRef(location.pathname);
  useEffect(() => {
    const currentBasePath = location.pathname + location.search;
    const previousBasePath = previousPath.current;
    if (currentBasePath !== previousBasePath) {
      callback(currentBasePath, previousBasePath);
    }

    previousPath.current = currentBasePath;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, [location.pathname, callback]);
};

export default usePageNavigation;
